"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useArrayField = exports.arrayMutators = void 0;
const final_form_arrays_1 = __importDefault(require("final-form-arrays"));
const react_1 = __importDefault(require("react"));
const react_final_form_arrays_1 = require("react-final-form-arrays");
const components_1 = require("../../components");
const icons_1 = require("../../icons");
const ArrayField = (props) => {
    const { onAdd, name, children, removable = true, ...rest } = props;
    return (react_1.default.createElement(react_final_form_arrays_1.FieldArray, { name: name, ...rest }, (renderProps) => (react_1.default.createElement(components_1.Box, { display: "flex", flexDirection: "column", gap: 2, width: "100%", alignItems: "flex-start" },
        renderProps.fields.map((name, index) => (react_1.default.createElement(components_1.Box, { key: name, display: "flex", flex: 1, width: "100%", gap: 2 },
            react_1.default.createElement(components_1.Box, { flex: 1 }, children?.({ name, index, ...renderProps })),
            removable && (react_1.default.createElement(components_1.Box, { mt: 1.5 },
                react_1.default.createElement(components_1.IconButton, { color: "error", size: "small", onClick: () => renderProps.fields.remove(index) },
                    react_1.default.createElement(icons_1.TrashAlt, null))))))),
        onAdd && (react_1.default.createElement(components_1.IconButton, { size: "medium", onClick: () => onAdd?.(renderProps.fields) },
            react_1.default.createElement(icons_1.PlusCircle, null)))))));
};
exports.arrayMutators = final_form_arrays_1.default;
exports.useArrayField = react_final_form_arrays_1.useFieldArray;
exports.default = ArrayField;
